/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import userService from '../../../../../Services/userService'
import './ApplicantProfile.scss'

import { Loader } from '../../../../../Components'
import { APPLICANT_SUCCESS } from '../../../../../Constants/ApplicantContacts'
import { useDispatch } from 'react-redux'
import ApplicationForm from '../Medical/AppForm/ApplicationForm'
import { useForm } from 'react-hook-form'
import applicantsService from '../../../../../Services/applicantsService'
import { act } from '@testing-library/react'
import DocumentTab from '../DocumentTab/DocumentTab'
import Review from '../reviewTab/Review'
import { ApplicantProfile } from '../../../Interfaces/Index'

const AutomatedApplicantProfile = () => {
  const { nin: refid } = useParams()
  const pathname = useLocation().pathname
  console.log('refid', refid)
  const [values, setValues] = useState<any>({})
  const [data, setData] = useState([{ name: '', value: '' }])
  const [loader, setLoader] = useState(false)
  const [submit, setSubmit] = useState<boolean>(false)
  const [activeTab, setActiveTab] = useState(null)
  const [saveV, setSaveV] = useState<any>()

  const handleTabClick = (tabName: any) => {
    setActiveTab(tabName === activeTab ? null : tabName)
  }
  const { register, handleSubmit, setValue, formState: { errors } } = useForm()
  const dispatcher = useDispatch()
  const navigate = useNavigate()
  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target
    console.log({ name, value })
    if (name === 'stateOfPermanent' && value !== undefined) {
      setSaveV(value)
    }
    setData({
      ...data,
      [name]: value
    })
  }

  const getData = async () => {
    setLoader(true)
    try {
      await userService.getDataSingle(refid).then((res: any) => {
        console.log('DANGER GGDDGGDGG', res.data)
        setLoader(false)
        setValues({ photo: res.data.photo, ...res.data.metadata, ...res.data.dataset.formData, ...res.data.dataset.workflow.pScreen.scheduleSchema })
        console.log('wahhh', { ...res.data.dataset.nimc, ...res.data.metadata })
        if (res.status === 500) {
          toast.error('Server error, redirecting...', { duration: 2000 })
          setTimeout(() => { window.location.href = '/applicants' }, 2000)
          return
        }
        dispatcher({ type: APPLICANT_SUCCESS, payload: { ...res.data.dataset.nimc, ...res.data.metadata, photo: res.data.photo, workflow: res.data.dataset.workflow } })
      }, (error: any) => {
        setLoader(false)
        // navigate('/applicants', { replace: true })
        console.log('DANGER ERROR', error)
        if (error.response && error.response.status === 500) {
          toast.error(error.response.data.message || 'Server error, redirecting...', { duration: 2000 })
          setTimeout(() => { window.location.href = '/applicants' }, 2000)
        } else {
          toast.error(error.response?.data?.message, { duration: 5000 })
        }
      })
    } catch (error: any) {
      setLoader(false)
      console.log('DANGER ERROR', error)
      if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message || 'Server error, redirecting...', { duration: 2000 })
        setTimeout(() => { window.location.href = '/applicants' }, 2000)
      } else {
        toast.error(error.response?.data?.message, { duration: 5000 })
      }
    }
  }

  useEffect(() => {
    if (refid) {
      getData()
    }
  }, [refid])

  console.log('medicalData', data)
  const onSubmit = handleSubmit(async () => {
    const nin = refid
    setSubmit(true)
    await applicantsService.submitPhysicalScreening({ ...data, nin }).then((res) => {
      console.log(res)
      toast.success('Submitted successfully', { duration: 3000 })
      navigate('/dashboard/', { replace: true })
      setSubmit(false)
    }, (error: any) => {
      console.log(error)
      setSubmit(false)
      toast.error(error.response.data.message, { duration: 5000 })
    })
  })
  const courseofStudy = 'COURSE-OF-STUDY'
  useEffect(() => {
    setValue('firstname', values.firstname)
    setValue('middlename', values.middlename)
    setValue('surname', values.surname)
    setValue('dob', values.dob)
    setValue('age', values.age)
    setValue('email', values.email)
    setValue('mobile', values.phone)
    setValue('nin', values.nin)
    setValue('mobile1', values.phone1)
    setValue('nextOfKinName', values.nextOfKinName)
    setValue('nextOfKinPhone', values.nextOfKinPhone)
    setValue('nextOfKinEmail', values.nextOfKinEmail)
    setValue('nextOfKinGender', values.nextOfKinGender)
    setValue('nextOfKinRelationship', values.nextOfKinRelationship)
    setValue('subject1', values?.firstSitting?.subject1)
    setValue('subject2', values?.firstSitting?.subject2)
    setValue('subject3', values?.firstSitting?.subject3)
    setValue('subject4', values?.firstSitting?.subject4)
    setValue('subject5', values?.firstSitting?.subject5)
    setValue('subject6', values?.firstSitting?.subject6)
    setValue('subject7', values?.firstSitting?.subject7)
    setValue('subject8', values?.firstSitting?.subject8)
    setValue('subject9', values?.firstSitting?.subject9)
    setValue('grade1', values?.firstSitting?.grade3)
    setValue('grade2', values?.firstSitting?.grade3)
    setValue('grade3', values?.firstSitting?.grade3)
    setValue('grade4', values?.firstSitting?.grade4)
    setValue('grade5', values?.firstSitting?.grade5)
    setValue('grade6', values?.firstSitting?.grade6)
    setValue('grade7', values?.firstSitting?.grade7)
    setValue('grade8', values?.firstSitting?.grade8)
    setValue('grade9', values?.firstSitting?.grade9)
    setValue('twosubject1', values?.secondSitting?.subject1)
    setValue('twosubject2', values?.secondSitting?.subject2)
    setValue('twosubject3', values?.secondSitting?.subject3)
    setValue('twosubject4', values?.secondSitting?.subject4)
    setValue('twosubject5', values?.secondSitting?.subject5)
    setValue('twosubject6', values?.secondSitting?.subject6)
    setValue('twosubject7', values?.secondSitting?.subject7)
    setValue('twosubject8', values?.secondSitting?.subject8)
    setValue('twograde9', values?.secondSitting?.subject9)
    setValue('twograde1', values?.secondSitting?.grade3)
    setValue('twograde2', values?.secondSitting?.grade3)
    setValue('twograde3', values?.secondSitting?.grade3)
    setValue('twograde4', values?.secondSitting?.grade4)
    setValue('twograde5', values?.secondSitting?.grade5)
    setValue('twograde6', values?.secondSitting?.grade6)
    setValue('twograde7', values?.secondSitting?.grade7)
    setValue('twograde8', values?.secondSitting?.grade8)
    setValue('twograde9', values?.secondSitting?.grade9)
    setValue('examYear', values?.sscedetails?.[0]?.examYear)
    setValue('examType', values?.sscedetails?.[0]?.examType)
    setValue('examNo', values?.sscedetails?.[0]?.examNo)
    setValue('oneexamYear', values?.sscedetails?.[1]?.examYear)
    setValue('oneexamType', values?.sscedetails?.[1]?.examType)
    setValue('oneexamNo', values?.sscedetails?.[1]?.examNo)
    setValue('firstSittingRegNo', values?.firstSittingRegNo)
    setValue('secondSittingRegNo', values?.secondSittingRegNo)
    setValue('courseOfStudy', values['COURSE-OF-STUDY'])

    setValue('remark', values?.remark)
    setValue('recommendation', values?.recommendation)
    setValue('agree', values?.agree)

    setValue('streetAddressOfPermanent', values?.streetAddressOfPermanent)
    setValue('stateOfPermanent', values?.stateOfPermanent)
    setValue('lgaOfPermanent', values?.lgaOfPermanent)
    setValue('maritalStatus', values?.maritalStatus)

    setValue('streetAddressOfResidence', values?.streetAddressOfResidence)
    setValue('stateOfResidence', values?.stateOfResidence)
    setValue('lgaOfResidence', values?.lgaOfResidence)
    // firstSittingRegNo

    // subject1
  }, [values])
  console.log('allvalues', values['COURSE-OF-STUDY'])
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'
  return (
    <div className="applicant-profile-modern">
      {/* Breadcrumb */}
      <div className="breadcrumb-section">
        <div className="breadcrumb-container">
          <Link to="/dashboard" className="breadcrumb-home">
            <i className="fa fa-home"></i>
            <span>Dashboard</span>
          </Link>
          <i className="fa fa-chevron-right breadcrumb-divider"></i>
          <span className="breadcrumb-current">Applicant Profile</span>
        </div>
      </div>

      {/* Profile Card */}
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar-section">
            <div className="avatar-wrapper">
              <img
                src={values.photo}
                className="profile-avatar"
                alt="Applicant"
              />
              {/* {values.photo} */}
            </div>
          </div>
          {/* {values.photo} */}
          <div className="profile-info-section">
            <div className="profile-info-grid">
              <div className="info-item">
                <span className="info-label">First Name</span>
                <span className="info-value">{values.firstname || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Middle Name</span>
                <span className="info-value">{values.middlename || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Surname</span>
                <span className="info-value">{values.surname || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Phone Number</span>
                <span className="info-value">{values.contactPhone || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Email</span>
                <span className="info-value">{values.email || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">State</span>
                <span className="info-value">{values.stateOfPermanent || '-'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">NIN Number</span>
                <span className="info-value">{values.nin || '-'}</span>
              </div>
              {/* <div className="info-item">
                <span className="info-label">JAMB Number</span>
                <span className="info-value">{values['EXAM-NO'] || '-'}</span>
              </div> */}
              {/* <div className="info-item">
                <span className="info-label">Title</span>
                <span className="info-value">{values.title || '-'}</span>
              </div> */}
              <div className="info-item">
                <span className="info-label">Gender</span>
                <span className="info-value">{values.gender === 'f' ? 'Female' : 'Male'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Card */}
      <div className="tabs-card">
        <div className="tabs-container">
          <button
            className={`tab-button ${activeTab === 'applicationForm' ? 'active' : ''}`}
            onClick={() => handleTabClick('applicationForm')}
          >
            <i className="fa fa-file-text"></i>
            <span>Application Form</span>
          </button>

          <button
            className={`tab-button ${activeTab === 'documentTab' ? 'active' : ''}`}
            onClick={() => handleTabClick('documentTab')}
          >
            <i className="fa fa-folder-open"></i>
            <span>Documents</span>
          </button>

          <button
            className={`tab-button ${activeTab === 'reviewTab' ? 'active' : ''}`}
            onClick={() => handleTabClick('reviewTab')}
          >
            <i className="fa fa-check-circle"></i>
            <span>PSC Review</span>
          </button>

          {isOfficer && (
            <button
              className={`tab-button ${activeTab === 'PhysicalScreen' ? 'active' : ''}`}
              onClick={() => handleTabClick('PhysicalScreen')}
            >
              <i className="fa fa-user-md"></i>
              <span>Physical Screen</span>
            </button>
          )}
        </div>
      </div>

      {/* Form Content */}
      <form onSubmit={onSubmit}>
        {activeTab === 'applicationForm' && (
          <ApplicationForm
            register={register}
            errors={errors}
            handleChange={handleChange}
            values={values}
            saveV={saveV}
          />
        )}

        {activeTab === 'documentTab' && (
          <DocumentTab
            register={register}
            errors={errors}
            handleChange={handleChange}
            values={values}
            refid={refid}
          />
        )}

        {activeTab === 'PhysicalScreen' && (
          <ApplicantProfile />
        )}

        {activeTab === 'reviewTab' && (
          <Review
            register={register}
            errors={errors}
            handleChange={handleChange}
            values={values}
          />
        )}

        {!isOfficer && activeTab === 'reviewTab' && (
          <div className="submit-card">
            <button
              type="submit"
              className="submit-button"
              disabled={submit}
            >
              {submit
                ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Submitting...
                </>
                  )
                : (
                <>
                  <i className="fa fa-check me-2"></i>
                  Submit Application
                </>
                  )}
            </button>
          </div>
        )}
      </form>

      <Outlet />
      <Loader show={loader}></Loader>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#333',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }}
      />
    </div>
  )
}

export default AutomatedApplicantProfile
